<template>
  <div class="boy_warphry">
    <el-card style="height:100%">
      <p>企业类型统计</p>
      <div ref="echartsINof" style="height:100%"></div>
    </el-card>
  </div>
</template>

<script>
import { infoGrtBoy } from "@/network";
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.handEchart();
  },
  methods: {
    async getInfoData() {
      const { code, data, msg } = await infoGrtBoy("r3");
      if (code) {
      }
    },
    handEchart() {
      let myechart = this.$echarts.init(this.$refs.echartsINof);
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },

        legend: {
          orient: "vertical",
          left: "right",
          top: "30%",
          align: "left",
          itemWidth: 10,
          itemHeight: 10,
        },
        series: [
          {
            name: "Radius Mode",
            type: "pie",
            radius: [30, 140],
            center: ["40%", "50%"],
            roseType: "radius",
            itemStyle: {
              borderRadius: 5,
            },
            label: {
              show: false,
            },
            data: [
              {
                value: 1548,
                name: "有限责任公司",
              },
              {
                value: 735,
                name: "有限责任公司分公司",
              },
              {
                value: 510,
                name: "其他有限责任公司",
              },
              {
                value: 434,
                name: "其他有限责任公司分公司",
              },
              {
                value: 335,
                name: "有限公司",
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myechart.setOption(option);
    },
  },
};
</script>

<style lang="less">
.boy_warphry {
  width: 100%;
  height: 100%;
  overflow: hidden;
  p {
    // padding: 20px 20px 0 20px;
  }
  .el-card__body {
    height: 100%;
  }
}
</style>
